<!-- Compact -->
<compact-layout [siteid]="siteid" [site]="companySite"></compact-layout>